export default "__VITE_ASSET__DbBXcLpw__"